import React, { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { validateForm } from "utils/validation";
import { EmployeePerformanceRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditEmployeePerformanceForm from "./components/EditEmployeePerformanceForm";
import fields from "../json/EmployeePerformance.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchAllData from "Hooks/useFetchAllData";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import { GetById, Update, GetAllEmployees } from "adminApi/EmployeePerformanceApi/EmployeePerformance";

const EditEmployeePerformance = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { formdata } = fields;

    // initialValues
    const initialValues = useMemo(() => {
        return formdata.reduce((acc, field) => {
            acc[field.name] = "";
            return acc;
        }, {});
    }, [formdata]);

    // useFormChange
    const {
        values,
        errors,
        handleChange,
        setValues,
        setErrors
    } = useFormChange(initialValues, EmployeePerformanceRules);

    // Fetch existing data by ID
    const { loading: loadingFetch } = useFetchFormDataById(
        id,
        formdata,
        GetById,
        setValues
    );

    // Fetch Employees
    const { data: employees = [] } = useFetchAllData(GetAllEmployees);

    // form submit
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            return await Update(id, formValues);
        },
        (vals) => {
            const err = validateForm(vals, EmployeePerformanceRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Performance Record Updated Successfully"
    );

    return (
        <>
            {(loadingSubmit || loadingFetch) && <Spinner isSpinner={true} />}
            <EditEmployeePerformanceForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                employees={employees}
            />
        </>
    );
};

export default EditEmployeePerformance;
